module.exports = __webpack_public_path__ + "media/customizations/regencyattracylakes/logo-new-022aa4de652e498a635ec1eccd1b6eec.png";